var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"action link",class:{ disabled: _vm.disabled},attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.click()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }